var render, staticRenderFns
import script from "./CodegenMixinWrapper.vue?vue&type=script&lang=js&"
export * from "./CodegenMixinWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b726dc6e",
  null
  
)

export default component.exports